var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',_vm._l(([..._vm.breadcrumbItems]),function(item){return _c('v-breadcrumbs-item',{key:item.key,attrs:{"to":item.to,"exact":"","exact-active-class":"v-breadcrumbs__item--exact-active"}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v(" mdi mdi-chevron-right ")]),_vm._v(" "+_vm._s(item.text)+" ")],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }